import React from 'react';
import { EpisodeInfo } from './EpisodeInfo';

export const EpisodeProfile: React.FC = () => {
  return <EpisodeInfo />;
};
